import { Button, Form, message, Modal } from 'antd';
import React, { FC, useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import OWRichTextEditor from '../../rich_text_editor/OWRichTextEditor';
import {
	updateContractWorkOrder,
	workOrdersRestCrudThunksForBuyer,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { getContractorWO } from '../../utils/WorkOrderUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';

const FORM_ID = 'work-order-tasks-form';

const WOAdditionalDetailsModal: FC<any> = ({
	onCancel,
	onSuccess,
	workOrder,
	updateWorkOrderPartially,
	isClientView,
	updateSubContractorInfo,
}): React.ReactElement => {
	const [form] = Form.useForm();

	const editorRef = useRef(null);

	const [saving, setSaving] = useState(false);

	const updateWODetail = useCallback(() => {
		return new Promise((resolve, reject) => {
			const description = editorRef && editorRef.current && editorRef.current.getContent();
			if (workOrder.description !== description) {
				const contractorWO = getContractorWO(workOrder, isClientView);

				if (contractorWO) {
					const newContractorWO = {
						id: contractorWO.id,
						updatedDescription: description,
					};
					updateSubContractorInfo(newContractorWO)
						.then((res) => resolve(res))
						.catch((err) => reject(err));
				} else {
					updateWorkOrderPartially(workOrder.id, { description })
						.then((res) => resolve(res))
						.catch((err) => reject(err));
				}
			} else resolve(workOrder);
		});
	}, [updateWorkOrderPartially, workOrder, isClientView, updateSubContractorInfo]);

	const handleSubmit = useCallback(
		(values) => {
			setSaving(true);
			updateWODetail()
				.then((updatedWO) => {
					onSuccess && onSuccess();
				})
				.catch((err) => message.error(err))
				.finally(() => setSaving(false));
		},
		[onSuccess, updateWODetail]
	);

	return (
		<Modal
			visible={true}
			width={800}
			title={`Work order details`}
			onCancel={onCancel}
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_ID}
					loading={saving}
				>
					Save
				</Button>,
			]}
			closable={true}
		>
			<Form layout="vertical" onFinish={handleSubmit} id={FORM_ID} form={form}>
				<Form.Item name="notes" label="Description">
					<OWRichTextEditor
						initialEditorState={workOrder.description || ''}
						editorRef={editorRef}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateWorkOrderPartially: (id, entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.updatePartially(id, entity)
				: workOrdersRestCrudThunksForBuyer.updatePartially(id, entity)
		),
	updateSubContractorInfo: (entity) => dispatch(updateContractWorkOrder(entity, 'id')),
});

const ComponentWithoutUserType = connect(
	mapStateToProps,
	mapDispatchToProps
)(WOAdditionalDetailsModal);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
